var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('img',{attrs:{"src":"img/habstash-logo.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }